module.exports = __webpack_public_path__ + "static/media/objects2_02.59a04423.svg";